import axios from 'axios';
import { getApiUrl } from './environment';

// Determine the API base URL based on environment
const getApiBaseUrl = () => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = window.location.port;
  const nodeEnv = process.env.NODE_ENV;
  
  console.log('API Config Debug:', {
    nodeEnv,
    protocol,
    hostname,
    port,
    location: window.location.href
  });
  
  const baseURL = getApiUrl();
  console.log('Using API baseURL:', baseURL);
  return baseURL;
};

// Create axios instance with base configuration
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
api.interceptors.request.use(
  (config) => {
    // FormData must set Content-Type automatically (with boundary); do not override
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    const token = localStorage.getItem('token');
    if (token && token.trim() && token !== 'null' && token !== 'undefined') {
      config.headers.Authorization = `Bearer ${token}`;
      // Fallback: also attach as query param for services stripping headers
      if (config.method && config.method.toLowerCase() === 'get') {
        config.params = { ...(config.params || {}), token };
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      // Handle unauthorized / invalid token
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Export the API instance and utility function
export const getBackendUrl = () => getApiUrl();

export default api;